/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_Item_PrefsInputs */

const en_us2_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your notification preferences`)
};

const pt_br2_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas preferências de notificação`)
};

const es_419_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus preferencias de notificación`)
};

const pt_pt2_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tuas preferências de notificação`)
};

const fr_fr2_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes préférences de notification`)
};

const de_de2_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Benachrichtigungseinstellungen`)
};

const it_it2_profile_editors_export_item_prefs = /** @type {(inputs: Profile_Editors_Export_Item_PrefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue preferenze di notifica`)
};

/**
* | output |
* | --- |
* | "Your notification preferences" |
*
* @param {Profile_Editors_Export_Item_PrefsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_item_prefs = /** @type {((inputs?: Profile_Editors_Export_Item_PrefsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_Item_PrefsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_item_prefs(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_item_prefs(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_item_prefs(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_item_prefs(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_item_prefs(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_item_prefs(inputs)
	return en_us2_profile_editors_export_item_prefs(inputs)
});
export { profile_editors_export_item_prefs as "profile-editors.export_item_prefs" }